/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/archive-1214663': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M10 13h4a1 1 0 000-2h-4a1 1 0 000 2zm9-10H5a3 3 0 00-1 5.82V18a3 3 0 003 3h10a3 3 0 003-3V8.82A3 3 0 0019 3zm-1 15a1 1 0 01-1 1H7a1 1 0 01-1-1V9h12zm1-11H5a1 1 0 010-2h14a1 1 0 010 2z"/>'
  }
})
